import React, {useState, useEffect} from 'react'
import { FaArrowRight, FaFilePdf } from 'react-icons/fa'
import {Link} from 'gatsby'
import {isUserInRegion} from '../services/auth'

const AccordionDetailPageList = ({items, contentType, userRegion}) => {
    let filteredItem = items.filter(item => isUserInRegion(userRegion, item.region))

    // {console.log('---> items: ', items)}

    return (
        <ul className="list-group list-group-borderless list-group-icon-primary-bg me-md-6">
            {
                filteredItem &&
                filteredItem.map((item, i) => (                    
                    <li key={i} className="list-group-item">
                        <FaArrowRight size={22} /> <Link to={'/' + contentType + '/' + item.slug.current || '#'}>{item.title}</Link>
                    </li>                        
                ))
            }
        </ul>
    )
}

export default AccordionDetailPageList